import { TGeoSuggestionValues, geoSuggestionTypes } from 'constants/geo';
import { GeoListType } from 'types/cargosApp/Geo';

import axios from '../axios';
import { TGeoCompletionResponse } from './types';

type TSupportedGeoTypes = Extract<TGeoSuggestionValues, 0 | 1 | 2>;

type TGeoDirection = { directions: { id: number; name: string }[] };

export const geoTypesMap = {
  [geoSuggestionTypes.country]: 'countries',
  [geoSuggestionTypes.region]: 'regions',
  [geoSuggestionTypes.city]: 'cities',
};

function getGeosByIds(ids: string[], geoType: TSupportedGeoTypes) {
  return axios.post(`/gw/gis-dict/public/v1/geo/${geoTypesMap[geoType]}/by-ids`, { ids });
}

function getGeoDirections() {
  return axios.get<TGeoDirection>('/gw/gis-dict/public/v1/directions');
}

export const maxCompletionListLength = 10;
function getGeoCompletionList(prefix: string, geoTypes: number) {
  return axios.post<TGeoCompletionResponse>('/gw/gis-dict/public/v1/autocomplete/suggestions', {
    prefix,
    suggestion_types: geoTypes,
    limit: maxCompletionListLength,
  });
}

function getPublicGeoLists() {
  return axios.get<GeoListType[]>('/webapi/public/firms/v1.0/lists/geo/global');
}

function getPrivateGeoLists() {
  return axios.get<GeoListType[]>('/webapi/firms/v1.0/lists/geo');
}

export { getGeoCompletionList, getPublicGeoLists, getPrivateGeoLists, getGeosByIds, getGeoDirections };
